module.exports = __webpack_public_path__ + "static/media/WellLife+_Program_Grid.d7ad441b.pdf";